export const SOCKET = 'SOCKET';
export const RECONNECT = 'reconnect';
export const RECONNECT_ATTEMPT = 'reconnect_attempt';
export const RECONNECT_ERROR = 'reconnect_error';
export const RECONNECT_FAILED = 'reconnect_failed';
export const DISCONNECT = 'disconnect';
export const UPDATE_CONNECTED_CLIENTS = 'socket/UPDATE_CONNECTED_CLIENTS';
export const DRAFT_OPENED = 'socket/DRAFT_OPENED';
export const DRAFT_CHANGED = 'socket/DRAFT_CHANGED';
export const DRAFT_SAVED = 'socket/DRAFT_SAVED';
export const SEND_UNSAVED_ACTIONS = 'socket/SEND_UNSAVED_ACTIONS';
export const SET_CONNECTED = 'socket/SET_CONNECTED';
